<template>
  <Main>
    <ToolsPanel :breadCrumbFirst="'Dictionary Items'" :title="'Dictionary Items'">
      <div class="list__buttons">
        <MainButton buttonWhite @click.native="handleCreate()">Create Items</MainButton>
        <MainButton @click.native="handleBackToList">Back</MainButton>
        <div v-if="langList.length" class="form-create__langs">
          <div
            v-for="lang in langList"
            :key="lang.id"
            @click="openLangModal(lang)"
            class="form-create__lang"
          >
            {{ lang.seoName }}
          </div>
        </div>
      </div>
    </ToolsPanel>
    <ContentContainer>
      <div v-if="dictionary" class="list">
        <div class="list__title">Dictionary: {{ dictionary.name }}</div>
        <div v-if="items.length">
          <CustomTable
            v-if="items.length"
            :data="items"
            :deleted-keys="tableOptions.deletedKeys"
            :rename-columns="tableOptions.renameColumn"
            :custom-order="tableOptions.customOrder"
            :is-action-block-visible="tableOptions.isActionBlockVisible"
            :handle-delete="handleDelete"
            :handle-edit="handleEdit"
            :handleFilter="handleFilter"
            :direction="directionSort"
            :order="orderSort"
          >
          </CustomTable>
        </div>
        <div class="list__no-have" v-else>No Dictionary Item found by this parameter.</div>
      </div>
    </ContentContainer>
    <ModalError
      :error-modal="false"
      :handle-close-error-modal="
        () => {
          this.error = {};
        }
      "
    />
    <MainModal v-if="deleteModal" :on-close="handleCloseConfirmModal" :modal-center="true">
      <div class="list__confirm">
        <div class="list__confirm-title">
          Do you want to delete the Dictionary Item - {{ deleteRow.name }}?
        </div>
        <div class="list__confirm-buttons">
          <div class="list__confirm-button">
            <MainButton buttonWhite @click.native="handleCloseConfirmModal">CANCEL</MainButton>
          </div>
          <div class="list__confirm-button">
            <MainButton @click.native="handleDeleteRow" :button-cancel="true">DELETE</MainButton>
          </div>
        </div>
      </div>
    </MainModal>

    <MainModal v-if="createModal || editModal" :on-close="handleCloseCreate" :modal-center="true">
      <div class="list__confirm">
        <template v-if="editModal">
          <div
            v-if="langList.length"
            class="form-create__langs"
            style="padding: 0 0 20px 0; margin-left: auto"
          >
            <div
              v-for="lang in langList"
              :key="lang.id"
              @click="openLangModalItem(lang)"
              class="form-create__lang"
            >
              {{ lang.seoName }}
            </div>
          </div>
        </template>
        <form @submit.prevent="handleSubmit(editModal)">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :onChange="setName"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :value="formDataToSend.name"
              :placeholder="'Name'"
              :error-messages="validationErrors['name']"
              isBordered
            />
          </div>
          <p class="form-create__label">SEO Name</p>
          <div class="input-container">
            <InputText
              :readonly="editModal"
              :onChange="setSeoName"
              :id="'seo_name'"
              :label="'seoName'"
              :value="formDataToSend.seo_name"
              :type="'text'"
              :placeholder="'SEOName'"
              :error-messages="validationErrors['seoName']"
              isBordered
            />
          </div>
          <div class="input-container">
            <MainCheckbox :label="'Active'" :id="'status'" :set-value="formDataToSend" />
          </div>
          <div v-if="error.message != undefined" class="form-create__error">
            {{ error.message }}
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Submit</MainButton>
          </div>
        </form>
      </div>
    </MainModal>
    <MainModal v-if="langModal" :on-close="closeLangModal" :modal-center="true">
      <div class="lang-modal">
        <div class="lang-modal__title">Translations for {{ chosenLang.name }}</div>
        <form @submit.prevent="handleSubmitLang">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSendLang"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :placeholder="'name'"
              isBordered
            />
            <div @click="handleTranslate('name', chosenLang.name)" class="form-create__translate">
              Translate (Chat GPT)
            </div>
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Update</MainButton>
          </div>
        </form>
      </div>
    </MainModal>
    <MainModal v-if="langModalItem" :on-close="closeLangModal" :modal-center="true">
      <div class="lang-modal">
        <div class="lang-modal__title">Translations for {{ chosenLang.name }}</div>
        <form @submit.prevent="handleSubmitLangItem">
          <p class="form-create__label">Name</p>
          <div class="input-container">
            <InputText
              :set-value="formDataToSendLang"
              :id="'name'"
              :label="'name'"
              :type="'text'"
              :placeholder="'name'"
              isBordered
            />
            <div
              @click="handleTranslateItem('name', chosenLang.name)"
              class="form-create__translate"
            >
              Translate (Chat GPT)
            </div>
          </div>
          <div class="form-create__btn">
            <MainButton :type="'submit'">Update</MainButton>
          </div>
        </form>
      </div>
    </MainModal>
    <MainModal v-if="deleteModalSuccess" :on-close="handleCloseSuccessModal">
      <div class="list__success-delete">
        Dictionary Item {{ deleteRow.name }} successfully deleted.
      </div>
    </MainModal>
    <FetchSpinnerModal v-if="loadingProcess" />
  </Main>
</template>

<script>
import { mapState } from "vuex";
import ROUTE from "~/constants/routes";
import referencesApi from "~/api/references";
import langApi from "~/api/lang";
import { seoTransform } from "~/helpers/seoTransform";

import Main from "~/templates/Main.vue";
import FetchSpinnerModal from "~/components/molecules/FetchSpinnerModal.vue";
import ToolsPanel from "~/components/molecules/ToolsPanel.vue";
import ContentContainer from "~/components/molecules/ContentContainer.vue";
import MainButton from "~/components/atoms/buttons/MainButton.vue";
import CustomTable from "~/components/molecules/CustomTable.vue";
import MainModal from "~/components/molecules/MainModal.vue";
import ModalError from "~/components/molecules/ModalError.vue";
import InputText from "~/components/atoms/inputs/InputText.vue";
import MainCheckbox from "~/components/atoms/inputs/MainCheckbox.vue";

export default {
  name: "DictionariesList",
  metaInfo: {
    title: "Dictionaries List",
  },
  data() {
    return {
      deleteModal: false,
      deleteRow: null,
      deleteModalSuccess: false,
      directionSort: true,
      createModal: false,
      editModal: false,
      items: [],
      dictionary: null,
      langEdit: false,
      langModal: false,
      langEditItem: false,
      langModalItem: false,
      chosenLang: null,
      chosenItem: null,

      formDataToSend: {
        name: "",
        id: null,
        seo_name: "",
        dictionary_id: "",
        status: false,
      },
      formDataToSendLang: {
        name: "",
      },
      orderSort: "id",
      tableOptions: {
        deletedKeys: ["translation", "null"],
        isActionBlockVisible: true,
        renameColumn: [
          {
            from: "id",
            to: "ID",
          },
          {
            from: "name",
            to: "Name",
          },
          {
            from: "seoName",
            to: "Seo name",
          },
          {
            from: "status",
            to: "Status",
          },
          {
            from: "translation",
            to: "translation",
          },
        ],
        customOrder: ["id", "name", "seoName", "translation", "status", "null"],
      },
    };
  },
  components: {
    Main,
    FetchSpinnerModal,
    ToolsPanel,
    ContentContainer,
    MainButton,
    CustomTable,
    MainModal,
    ModalError,
    InputText,
    MainCheckbox,
  },
  mounted() {
    this.getList();
    this.getLang();
  },
  watch: {
    $route(to, from) {
      this.getList();
    },
  },
  computed: {
    ...mapState("lang", ["lang", "langList"]),
    ...mapState("references", ["error", "loadingProcess", "validationErrors"]),
  },
  methods: {
    getList() {
      const url = `/${this.$route.params.id}`;
      referencesApi
        .getDictionaryDetail(url)
        .then((res) => {
          this.$store.commit("references/setLoading", false);
          if (res.success) {
            this.dictionary = res.data;
          }
        })
        .catch((error) => {
          this.$store.commit("references/setLoading", false);
          console.log(error);
        });

      referencesApi
        .getDictionaryItems(url)
        .then((res) => {
          this.$store.commit("references/setLoading", false);
          if (res.success) {
            this.items = res.data.items;
          }
        })
        .catch((error) => {
          this.$store.commit("references/setLoading", false);
          console.log(error);
        });
    },
    handleFilter(column) {
      this.orderSort = column;
      if (this.directionSort === null) {
        this.directionSort = true;
      } else {
        this.directionSort = !this.directionSort;
      }
      this.getList();
    },
    handleDelete(row) {
      this.deleteModal = true;
      this.deleteRow = row;
    },
    handleEdit(row) {
      this.formDataToSend.id = row.id;
      this.formDataToSend.dictionary_id = this.dictionary.id;
      this.formDataToSend.name = row.name;
      this.formDataToSend.seo_name = row.seoName;
      this.formDataToSend.status = row.status;
      this.editModal = true;
      this.chosenItem = row;
    },
    handleCreate() {
      this.formDataToSend.dictionary_id = this.dictionary.id;
      this.createModal = true;
    },
    handleCloseConfirmModal() {
      this.deleteModal = false;
    },
    handleCloseCreate() {
      this.createModal = false;
      this.editModal = false;

      this.formDataToSend.name = "";
      this.formDataToSend.seo_name = "";
      this.formDataToSend.status = false;
      this.formDataToSend.id = null;
    },
    handleDeleteRow() {
      const url = `/${this.deleteRow.id}?soft=1`;
      this.$store.commit("references/setLoading", true);
      referencesApi
        .deleteDictionaryItems(url)
        .then((res) => {
          this.$store.commit("references/setLoading", false);
          if (res.success) {
            this.getList();
            this.handleCloseConfirmModal();
            this.deleteModalSuccess = true;
          }
        })
        .catch((error) => {
          this.$store.commit("references/setLoading", false);
          console.log(error);
        });
    },

    handleCloseSuccessModal() {
      this.deleteModalSuccess = false;
    },
    closeModal(edit) {
      this.error = null;
    },
    handleSubmit(edit = false) {
      const data = {
        name: this.formDataToSend.name.length ? this.formDataToSend.name.trim() : "",
        seo_name:
          this.formDataToSend.seo_name.length != undefined
            ? this.formDataToSend.seo_name.trim()
            : "",
        status: this.formDataToSend.status ? 1 : 0,
        dictionary_id: this.formDataToSend.dictionary_id,
      };
      const url = `/${this.formDataToSend.id}`;
      if (edit) {
        referencesApi
          .editDictionaryItems(url, data)
          .then((res) => {
            this.$store.commit("references/setLoading", false);
            if (res.success) {
              this.getList();
              this.handleCloseCreate();
            }
          })
          .catch((error) => {
            this.$store.commit("references/setLoading", false);
            const { data } = error.response;
            this.$store.commit("references/setError", data);
            if (data.errors) {
              this.$store.commit("references/setValidationErrors", data.errors);
            }
          });
      } else {
        referencesApi
          .createDictionaryItems(data)
          .then((res) => {
            this.$store.commit("references/setLoading", false);
            if (res.success) {
              this.getList();
              this.handleCloseCreate();
            }
          })
          .catch((error) => {
            this.$store.commit("references/setLoading", false);
            const { data } = error.response;
            this.$store.commit("references/setError", data);
            if (data.errors) {
              this.$store.commit("references/setValidationErrors", data.errors);
            }
          });
      }
    },

    setName(value) {
      this.formDataToSend.name = value.trim();
      this.setSeoName(value);
    },
    setSeoName(data) {
      if (this.editModal) {
        return;
      }
      const value = seoTransform(data);
      this.formDataToSend.seo_name = value;
    },
    handleBackToList() {
      this.$router.push({
        path: ROUTE.DICTIONARY.replace(":page", 1),
      });
    },
    getLang() {
      let url = ``;
      this.$store.dispatch("lang/getLangList", url);
    },
    closeLangModal() {
      this.chosenLang = null;
      this.langModal = false;
      this.langModalItem = false;
      this.formDataToSendLang.name = "";
      this.langEdit = false;
      this.langEditItem = false;
      this.chosenItem = null;
    },
    openLangModal(lang) {
      this.langModal = true;
      this.chosenLang = lang;

      const translate = this.dictionary.translation;
      let translateDictionary = translate.find((item) => item.langId === this.chosenLang.id);
      if (translateDictionary) {
        this.formDataToSendLang.name = translateDictionary.name;
        this.langEdit = true;
      }
    },
    openLangModalItem(lang) {
      this.langModalItem = true;
      this.chosenLang = lang;

      const translate = this.chosenItem.translation;
      let translateLang = translate.find((item) => item.langId === this.chosenLang.id);
      if (translateLang) {
        this.formDataToSendLang.name = translateLang.name;
        this.langEdit = true;
      }
    },
    handleSubmitLang() {
      this.$store.commit("references/setLoading", true);
      const data = {
        name: this.formDataToSendLang.name,
        dictionary_id: this.dictionary.id,
        lang_id: this.chosenLang.id,
      };
      if (this.langEdit) {
        langApi
          .editLangDictionary(data, `/${this.formDataToSendLang.id}`)
          .then(() => {
            this.$store.commit("references/setLoading", false);
            this.closeLangModal();
            this.getList();
          })
          .catch((error) => {
            this.$store.commit("references/setLoading", false);
            console.log(error);
          });
      } else {
        langApi
          .createLangDictionary(data)
          .then(() => {
            this.$store.commit("references/setLoading", false);
            this.closeLangModal();
            this.getList();
          })
          .catch((error) => {
            this.$store.commit("references/setLoading", false);
            console.log(error);
          });
      }
    },
    handleSubmitLangItem() {
      this.$store.commit("references/setLoading", true);
      const data = {
        name: this.formDataToSendLang.name,
        dictionary_item_id: this.chosenItem.id,
        lang_id: this.chosenLang.id,
      };
      if (this.langEdit) {
        langApi
          .editLangDictionaryItems(data, `/${this.formDataToSendLang.id}`)
          .then(() => {
            this.$store.commit("references/setLoading", false);
            this.closeLangModal();
            this.handleCloseCreate();
            this.getItem();
          })
          .catch((error) => {
            this.$store.commit("references/setLoading", false);
            console.log(error);
          });
      } else {
        langApi
          .createLangDictionaryItems(data)
          .then(() => {
            this.$store.commit("references/setLoading", false);
            this.closeLangModal();
            this.handleCloseCreate();
            this.getItem();
          })
          .catch((error) => {
            this.$store.commit("references/setLoading", false);
            console.log(error);
          });
      }
    },
    handleTranslate(el, lang) {
      this.$store.commit("references/setLoading", true);
      const data = {
        text: this.dictionary[el],
        language: lang,
      };
      langApi
        .getTranslation(data)
        .then((res) => {
          this.$store.commit("references/setLoading", false);
          this.formDataToSendLang[el] = res.data.response;
        })
        .catch((error) => {
          this.$store.commit("references/setLoading", false);
          console.log(error);
        });
    },
    handleTranslateItem(el, lang) {
      this.$store.commit("references/setLoading", true);
      const data = {
        text: this.chosenItem[el],
        language: lang,
      };
      langApi
        .getTranslation(data)
        .then((res) => {
          this.$store.commit("references/setLoading", false);
          this.formDataToSendLang[el] = res.data.response;
        })
        .catch((error) => {
          this.$store.commit("references/setLoading", false);
          console.log(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.list {
  &__buttons {
    display: flex;
    /deep/.button-main {
      margin-left: 10px;
      white-space: nowrap;
    }
  }
}
/deep/.custom-table__header,
/deep/.custom-table__row {
  grid-template-columns: 0.4fr 1fr 1fr 1fr 1fr !important;
}
</style>
